export const BREAK_POINT = 768;



// WEBPACK FOOTER //
// ./src/constants/responsive.ts